/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { TurnkeySessionResponse, TurnkeySessionVars } from '../openapi-types.gen.js';

export type { TurnkeySessionResponse, TurnkeySessionVars } from '../openapi-types.gen.js';

export const useTurnkeySession = createMutationHook<TurnkeySessionVars, TurnkeySessionResponse, unknown>({
  specName: 'useTurnkeySession',
  path: '/v1/auth/turnkey-session',
  method: 'POST',
  resolveUrl: (vars: TurnkeySessionVars) => `/v1/auth/turnkey-session`,
  buildBody: (vars: TurnkeySessionVars) => ({ turnkeySessionJwt: vars.turnkeySessionJwt, email: vars.email, embeddedWallets: vars.embeddedWallets, externalWalletAddress: vars.externalWalletAddress, signupMethod: vars.signupMethod, oauthProfile: vars.oauthProfile, xUserId: vars.xUserId, providerUserId: vars.providerUserId, oidcToken: vars.oidcToken }),
  parseResponse: (raw: unknown): TurnkeySessionResponse => raw as TurnkeySessionResponse,
  
  
  
});
